import { makeCanonicalizerAPI, searchQuerySet } from "@searchui-searchforms/shared/canonicalizer";

export const { urlToDataModel, dataModelToQueryString } = makeCanonicalizerAPI({
    paths: {
        Search: { path: "/search", querySet: "search" },
    },
    querySets: {
        search: searchQuerySet,
    },
});
